<template lang="pug">
  #safe
    .title 
      .safe_name 安全管理
      el-popover(placement='bottom' width='277' trigger='click' popper-class='popover')
        .title 新建问题类型
        ul.nav
          li(v-for='(item, index) in popoNavList' :key='index' @click='creatIssBtn(item)')
            img(:src='item.iconPrefix')
            span {{ item.name }}
        el-button(slot='reference' type='primary' size='mini')
          i.el-icon-plus(style='margin-right:5px')
          | 新建安全管理流程
    .safe_nav
      el-tabs(v-model='activeName',type='card' @tab-click='handleClick')
        el-tab-pane(v-for="(item,index) in navList" :label='item.name' :name='item.id' :key="index")
    .safe_content
      .safe_content_select
        el-form.demo-form-inline(:inline='true',size="small" :model='selectForm' label-width="80px")
          el-form-item(label='流程名称:')
            el-input(v-model='selectForm.qualityName' placeholder='流程名称' @input="getTableData(1)")
          el-form-item(label='问题状态:')
           el-select(v-model='selectForm.qmstatus' placeholder="请选择" clearable filterable @change="getTableData(1)")
            el-option(v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value")
          el-form-item(label='创建人:')
            el-input(v-model='selectForm.createUserName' placeholder='创建人' @input="getTableData(1)" clearable)
          el-form-item(label='创建时间:')
            el-date-picker(v-model='selectForm.startDate' type='daterange' value-format='yyyy-MM-dd'  @change="getTableData(1)"
              format='yyyy-MM-dd' range-separator='至' start-placeholder='开始日期' end-placeholder='结束日期' size='small')
          el-form-item(label='截至日期:')
            el-date-picker(v-model='selectForm.endDate' type='daterange' value-format='yyyy-MM-dd' @change="getTableData(1)"
              format='yyyy-MM-dd' range-separator='至' start-placeholder='开始日期' end-placeholder='结束日期' size='small')
          el-form-item
            el-button(type='primary' plain @click='reset') 重置
            el-button(type='primary' @click='getTableData(1)') 查询
      .safe_content_table
        el-table.cqdz-table(height="100%",:data="safeList",:header-cell-style="headerCellStyle")
          el-table-column(label="序号", type="index",align="center") 
          el-table-column(label="安全管理流程名称", prop="qualityName") 
          el-table-column(label="关联模型名称",prop="modelName" ,align="center") 
          el-table-column(label="类型",prop="processType",align="center") 
          el-table-column(label="截止日期",prop="endDate") 
          el-table-column(label="问题状态",prop="qmstatus",align="center") 
            template(slot-scope="{row}")
              span.table_class.adopt_class(v-if="row.qmstatus == '已完成'") {{ row.qmstatus }}
              span.table_class.approval_class(v-if="row.qmstatus == '进行中'") {{ row.qmstatus }}
              span.table_class.reject_class(v-if="row.qmstatus == '已延期'") {{ row.qmstatus }}
          el-table-column(label="创建时间",prop="startDate",align="center") 
          el-table-column(label="创建人",prop="createUserName",align="center")
          el-table-column(label="操作")
            template(slot-scope="scope")
              el-button(type="text" @click.stop="clickChange(scope.row)") 详 情
      .pagelist 
        pagina.el-pagination(:page='page' @handleSizeChange='handleChange' @handleCurrentChange='fetchData')
    el-dialog.dialogQua(v-dialogDrag title='关联模型' :visible.sync='dialogVisible' :close-on-click-modal='false' :close-on-press-escape='false' width='500px')
      .diatitle 是否需要关联模型节点
      el-tree(:data='treeList' :props='defaultProps' default-expand-all :expand-on-click-node='false' 
        node-key='folderId' ref='tree' :highlight-current='true' @current-change='currentOrgChangeHandler')
        template(#default='{ data }')
          .treeContent
            img.imgCont(:src='stageImg' alt='阶段图片' v-if="data.folderType=='2'")
            img.imgCont(:src='classImg' alt='分类图片' v-else-if="data.folderType=='0'")
            img.imgCont(:src='nodeImg' alt='节点图片' v-else-if="data.folderType=='1'")
            span(style='font-size:14px') {{ data.folderName }}
      span.dialog-footer(slot='footer')
        el-button(@click='cancelHander' size='small') 取 消
        el-button(type='primary' size='small' @click='addModel') 确 定
    el-dialog.dialogQua.dialogFormQua(v-dialogDrag :visible.sync='dialogVisibleForm' 
      :title="userInfo.name+' 发起流程'" :close-on-click-modal='false' :close-on-press-escape='false' width='1200px')
      flowFlow(:key='updateKey',ref='flowFlow',@isLaunchBtn='startFlow')
      span.dialog-footer(slot='footer')
        el-button(@click='cancelHanderForm' size='small') 取 消
        el-button(type='primary' @click='addHander()' size='small' v-if='isLaunch' ) 发起审批
    el-dialog.dialogQua.dialogFormQua(v-dialogDrag :visible.sync='dialogVisibleDetail' 
      title="详 情" :close-on-click-modal='false' :close-on-press-escape='false' width='1200px')
      formDetail(ref='formDetail')
      span.dialog-footer(slot='footer')
        el-button(@click='dialogVisibleDetail=false' size='small') 取 消
</template>

<script>
import quaMangeService from "@/xgzdService/quaMange-service"
import flowService from "@/CommonDP/service/flow-service";
import bimManage from "@/xgzdService/bimManage-service"
import { mapState } from "vuex";
import flowFlow from "./../quaMange/flowForm.vue"
import formDetail from './../quaMange/modules/formDetail.vue'
import pagina from "@/CommonDP/components/paging";
export default {
  components:{pagina,flowFlow,formDetail},
  data () {
    return {
      activeName:"",
      list:[
        { name:'全部',id:"", },
      ],
      selectForm:{
        questionName:'',
        flowName:"",
        startDate:'',
        endDate:'',
      },
      page: { pageNo: 1, pageSize: 10, totalCount: 0, },
      safeList:[],
      popoNavList:[],
      treeList:[],
      dialogVisible:false,
      dialogVisibleForm:false,
      stageImg:require(`@/views/assets/stage.png`),
      nodeImg:require(`@/views/assets/node.png`),
      classImg:require(`@/views/assets/class.png`),
      defaultProps: {
        children: 'childList',
        label: 'folderName'
      },
      modelId:'',
      updateKey:0,
      isLaunch:false,
      statusList:[
        {label:"进行中",value:"1"},
        {label:"已延期",value:"2"},
        {label:"已完成",value:"3"},
      ],
      dialogVisibleDetail:false
    }
  },
  computed:{
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo,
      routerParams: (state) => state.projectMg.routerParams,
    }),
    navList(){
      return [...this.list,...this.popoNavList]
    },
    tableParams(){
      const {endDate, startDate, qmstatus, createUserName, qualityName} =this.selectForm;
      const processType = this.popoNavList.find(ele=>ele.id==this.activeName)?.name||"";
      const params={
        endDateBeginStr:endDate?endDate[0]:"",
        endDateEndStr:endDate?endDate[1]:"",
        startDateBeginStr:startDate?startDate[0]:"",
        startDateEndStr:startDate?startDate[1]:"",
        type:"1",
        qmstatus:qmstatus?.split(""),
        createUserName,
        qualityName,
        processTypeIds:this.activeName=="0"?[]:this.activeName.split(","),
        processType,
        prjId:this.prjInfo.prjId,
        enterpriseId:this.enterpriseId
      };
      return params
    },
    qualitySubmitParam(){
      const {enterpriseId,prjInfo:{prjId}}=this;
      const json = this.$refs.flowFlow.$refs.businessForm.getFormData();
      return {
        endDate:json.endDate||"",
        processTypeId:this.routerParams.flowDefinitionId,
        processType:this.routerParams.name,
        qualityName:json.title,
        type:"1",
        modelId:"",//关联的节点id
        prjId,
        enterpriseId,
      }
    },
  },
  mounted(){
    this.getTree()
  },
  methods:{
    async getTree() {
      this.popoNavList=[];
      const res = await flowService.queryGroupInfoList(this.enterpriseId);
      let list = []
      for (const iterator of res.data) {
        if(iterator.flowGroupDto.name=="安全巡检") list =  iterator.flowDefinitionDtoList
      }
      this.popoNavList=list.map((item) => {
        item.iconPrefix= this.getImgUrl(item.iconPrefix);
        return item
      });
      this.getTableData(1)
    },
    getImgUrl(content) {
      return require(`@/CommonDP/assets/xunhun/${content}.png`);
    },
    handleChange(val) {
      this.page.pageSize = val;
      this.getTableData(1);
    },
    fetchData(val) {
      this.getTableData(val);
    },
    async getTableData(index){
      this.safeList = [];
      const params={
        pageNum:index,
        pageSize:this.page.pageSize,
        ...this.tableParams
      }
      const {data,pageNum,totalCount} =await quaMangeService.qualityGet(params);
      this.safeList = data;
      this.page.pageNo=pageNum;
      this.page.totalCount=totalCount;
    },
    creatIssBtn(val){
      this.dialogVisible=true;
      this.getTreeList();
      let params= {
        status: null,
        currentVersionId: val.currentVersionId,
        iconPrefix: val.iconPrefix,
        groupId: val.groupId || "",
        flowDefinitionId: val.id,
        name: val.name,
        flowDescribe: val.flowDescribe,
        flowKey: val.flowKey,
        flowInstanceId: val.flowInstanceId,
        flowBusinessId: val.flowBusinessId,
      };
      this.$store.dispatch("setRouterParams", params);
    },
    async getTreeList(){
      const{prjInfo:{prjId},enterpriseId}=this;
      const {data}=await bimManage.getFolderTree(prjId,enterpriseId);
      this.treeList=data.map((item)=>{
        if(item.parentId==="0")  item.folderType = "2"
        return item
      });
    },
    handleClick(tab, event) {
      this.getTableData(1);
    },
    //选模型节点取消
    cancelHander(){
      this.dialogVisibleForm=true;
      this.updateKey++
    },
    //选模型节点确定
    addModel(){
      if(this.modelId){
        this.getModel(this.modelId)
      }else{
        this.$message.warning("请先选择模型节点")
      }
    },
    //获取模型节点下面的模型
    async getModel(modelId){
      const {data} = await bimManage.getMoDelByNodeId(modelId);
      if(data&&data.length){
        const fileIds = data.map((item) => item.modeId).join();
        const fileNames = data.map((item) => item.modeName).join();
        const rvtVersion = data.map((item) => item.modelFileVersion).join();
        const noNeedIssue = 'yes';
        const noquaFlow = '1';
        const modelId=this.modelId;
        const {prjId,prjName}=this.prjInfo;
        const { href } = this.$router.resolve({ path: "/modelpro" ,query: { fileIds, fileNames, prjId, prjName, rvtVersion,noNeedIssue,noquaFlow,modelId} });
        window.open(href, "_blank");
      }else{
        this.$message.warning("该节点下面暂无模型，请重新选择")
      }
      
    },
    cancelHanderForm(){
      this.dialogVisibleForm=false;
      this.dialogVisible=false;
    },
    startFlow(val){
      this.isLaunch=val;
    },
    currentOrgChangeHandler(val){
      this.modelId=val.folderId;
    },
    reset(){
      this.selectForm = {};
      this.getTableData(1);
    },
    async addHander(){
      const params=this.$refs.flowFlow.getForm()
      if (!this.$refs.flowFlow.$refs.businessForm.validateFormData())return;
      const {data} = await quaMangeService.addFlowBusiness(params);//添加流程接口
      const submitparams={
        flowBusinessId:data,
        ...this.qualitySubmitParam
      };
      await quaMangeService.qualityAdd(submitparams);//添加问题接口
      await this.$success('发起流程成功');
      await this.getTableData(1);
      this.dialogVisibleForm=false;
      this.dialogVisible=false;
    },
    async clickChange(row){
      const {data} =await quaMangeService.getFormDataByBusinessID(row.flowBusinessId);
      let params = {
        status: data.status,
        flowBusinessId: data.flowBusinessId,
        flowInstanceNodeId: data.currentNodeId,
        flowKey: data.businessType,
        flowInstanceId: data.flowInstanceId,
        flowDefinitionId: data.flowDefinitionId,
      };
      this.$store.dispatch("setRouterParams", params);
      this.dialogVisibleDetail=true;
    },
    headerCellStyle({ rowIndex }) {
      if (rowIndex === 0) return 'background: rgb(247, 249, 255)';
    }
  }
}
</script>
<style lang="scss">
.popover{
  height: 198px;
  .title{
    color: #323232;
    font-size: 14px;
    padding: 0 3px;
    margin-bottom: 13px;
    height: auto !important;
    border-bottom: none !important;
  }
  .nav{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    height: calc(100% - 24px);
    li{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 33%;
      cursor: pointer;
    }
  }
}
.dialogQua{
  .el-dialog__body{
    height: 500px;
    overflow: auto;
  }
  .diatitle{
    color: #323232;
    font-size: 14px;
  }
  .treeContent{
    display:flex;
    align-items:center;
    .el-icon-circle-plus{
      margin-left: 20px;
      font-size: 16px;
    }
    .imgCont{
      margin-right: 6px;
    }
  }
}
.dialogFormQua{
  .el-dialog__title{
    font-size: 16px;
    color: #323232;
  }
  .el-dialog__body{
    background: #F4F5FA;
    height: 650px;
    padding:11px 16px 0 16px !important
  }
}
</style>
<style lang="scss" scoped>
#safe{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  background-color: #fff;
}
.title{
  height: 50px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(211, 217, 232, 0.77);
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .safe_name{
    color: #323232;
    font-weight: 600;
    font-size: 18px;
  }
}
.safe_nav{
  padding: 5px 0 0 20px;
  /deep/.el-tabs__item{
    font-size: 14px !important;
    font-weight: 500 !important;
  }
}
.safe_nav::before{
  content: "";
  position: absolute;
  top: 46px;
  left: 0px;
  width: 20px;
  height: 50px;
  box-sizing: border-box;
  border-bottom:1px solid #E4E7ED
}
.safe_content{
  flex: 1 1;
  display: flex;
  flex-flow: column nowrap;
  &_select{
    padding: 0 20px;
  }
  &_table{
    flex: 1 1;
    padding: 0 20px;
  }
  .pagelist{
    // height: 50px;
    display: flex;
    flex-flow: row-reverse nowrap;
    align-items: center;

  }
}
.table_class {
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 7px;
}
.approval_class {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}
.adopt_class {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
}
.reject_class {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}

</style>
